<section class="facsec2" [style.background]="background">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h2 [ngClass]='styleTitle' style="text-align:center;">{{title}}
                </h2>
                <app-carousel [cards]="cards" ></app-carousel>
           
            </div>
        </div>
    </div>
</section>